module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 116.61f6041a.png";